import { Session } from '@shared/app/scripts/services/session';
import { intersection } from 'lodash';

/**
 * A directive which can be used to show or hide an element based on a user's
 * roles. This directive relies on the {@link sharedModule.currentSession}
 * to contain a roles array in order to get a list of roles.
 *
 * When multiple roles are provided, only one is required to match - OR operation.
 *
 * @example
 * # Code
 * $scope.allowedRoles = ['owner'];
 *
 * # HTML
 * <button sw-allowed="$scope.allowedRoles">Test Button</button>
 */
// TODO add unit test
angular
  .module('coreModule')
  .directive('swAllowed', ($parse: ng.IParseService, session: Session) => ({
    restrict: 'A',

    link: function (scope, element, attr) {
      const role = $parse(attr.swAllowed)(scope);
      let roleMatches = false;

      session.current$.subscribe((sessionCurrent) => {
        const tenantId = sessionCurrent.tenantId;

        if (tenantId) {
          roleMatches = Boolean(
            intersection(role, sessionCurrent.roles[tenantId]).length,
          );
        }

        if (tenantId && !roleMatches) {
          element.addClass('ng-hide');
        } else if (!tenantId) {
          element.addClass('ng-hide');
        } else {
          element.removeClass('ng-hide');
        }
      });
    },
  }));
